import type { Reference } from '@ps/web-martech-cms-types';

export default function addWidgetState<T, S = Record<string, unknown>, K extends string = ''>(
  uid: Reference['uid'],
  state = {},
  params: Partial<T> | Record<K, Partial<S>>
) {
  return { reduxState: { [uid]: { ...state, ...params } } };
}
